<fa-icon
   *ngIf="isBrickSettingAvailable$ | async"
   class="brick-settings-button"
   [fixedWidth]="true"
   [icon]="settingsIcon"
></fa-icon>
